const formatIndianNumber = (value) => {
  const num = Number(value);
  if (isNaN(num)) return value; // fallback if not a number

  const absNum = Math.abs(num);
  let formatted = "";

  if (absNum >= 10000000) {
    // 1 crore = 1,00,00,000
    formatted = (absNum / 10000000).toFixed(1).replace(/\.0$/, "") + " cr";
  } else if (absNum >= 100000) {
    // 1 lakh = 1,00,000
    formatted = (absNum / 100000).toFixed(1).replace(/\.0$/, "") + " L";
  } else if (absNum >= 1000) {
    // thousands
    formatted = (absNum / 1000).toFixed(1).replace(/\.0$/, "") + " K";
  } else {
    // below 1000 – normal Indian formatting
    return num.toLocaleString("en-IN");
  }

  // preserve sign for negative numbers
  return num < 0 ? `-${formatted}` : formatted;
};

export default formatIndianNumber;
